import * as i18nextModule from "i18next";
import { reactI18nextModule } from "react-i18next";

import br from "./locales/pt-BR.json";
import en from "./locales/en-US.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import pt from "./locales/pt-PT.json";

const i18n: any = (i18nextModule as any).default || (i18nextModule as any);

const resources = {
  'en-US': { translation: en },
  'pt-BR': { translation: br },
  'pt-PT': { translation: pt },
  'es-ES': { translation: es },
  'fr-FR': { translation: fr },
} as const;

if (!i18n.isInitialized) {
  i18n.use(reactI18nextModule as any).init({
    resources,
    lng: "pt-BR",
    fallbackLng: "pt-BR",
    interpolation: { escapeValue: false },
  });

  const SAVED_LANG_KEY = "app.lang";
  const saved = localStorage.getItem(SAVED_LANG_KEY);
  if (saved && i18n.language !== saved) i18n.changeLanguage(saved);
  i18n.on("languageChanged", (lng: string) => {
    localStorage.setItem(SAVED_LANG_KEY, lng);
  });
}

export default i18n;
